import { FC, CSSProperties } from 'react';
import { useTheme } from '@material-ui/core';
import { WbBadge } from '../../WbBadge';
import { KoFilledIcon } from './Icons';
import { useStyles } from './style';
import { WbInfoTooltip } from '../../WbInfoTooltip';

interface Props {
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const NotExecutedIcon: FC<Props> = ({ style, variant = 'default' }) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <WbInfoTooltip
      variant={variant === 'reduced' ? undefined : 'provided-button'}
      title="Failed. You need to solve the errors reported since they will prevent the deployment"
      icon={
        variant === 'reduced' ? (
          <span>
            <KoFilledIcon
              htmlColor={theme.palette.error.main}
              className={classes.icon}
              style={style}
            />
          </span>
        ) : (
          <WbBadge color="error" startIcon={<KoFilledIcon fontSize="small" />}>
            Not Executed
          </WbBadge>
        )
      }
    />
  );
};
